import { Component, Prop, State, h } from '@stencil/core';

import { generateQRCode } from '../../../actions/actions.qrcode';
import { QRCodeErrorCorrectionLevel, QRCodeParams } from '../../../interfaces/interface.qrcode';

@Component({
  tag: 'qr-code',
  styleUrl: 'qr-code.css',
})
export class QRCode {
  @Prop() url: string;
  @Prop() widthPx: number = 200;
  @Prop() errorCorrectionLevel: QRCodeErrorCorrectionLevel = 'M';
  @Prop() margin: number = 4;
  @Prop() color?: { dark?: string; light?: string };

  @State() qrCodeDataUrl: string = '';
  @State() error: string = '';

  async componentDidLoad() {
    const result = await generateQRCode({
      url: this.url,
      widthPx: this.widthPx,
      errorCorrectionLevel: this.errorCorrectionLevel,
      margin: this.margin,
      color: this.color,
    } as QRCodeParams);

    if (result.success) {
      this.qrCodeDataUrl = result.dataUrl;
      this.error = '';
    } else {
      this.error = `Error: ${result.error}`;
      this.qrCodeDataUrl = '';
    }
  }

  render() {
    return (
      <div data-testid="qr-code" class="flex items-center justify-center" style={{ width: `${this.widthPx}px` }}>
        {this.error ? (
          <div class="text-red-500 text-center p-2.5">{this.error}</div>
        ) : this.qrCodeDataUrl ? (
          <img src={this.qrCodeDataUrl} alt={`QR Code for ${this.url}`} class="max-w-full max-h-full h-auto" style={{ width: `${this.widthPx}px` }} />
        ) : (
          <div class="text-center p-2.5">Generating QR code...</div>
        )}
      </div>
    );
  }
}
